import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #1e4d92 0%, #2d8fe5 100%);
  padding: 2rem;
`;

const Card = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  padding: 3rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.1);
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #1e4d92;
  text-align: center;
  margin-bottom: 2rem;
`;

const DataDisplay = styled.div`
  margin-bottom: 2rem;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
`;

const Button = styled.button`
  flex: 1;
  padding: 1rem;
  font-size: 1.2rem;
  font-weight: bold;
  color: white;
  background: ${props => props.secondary ? '#6c757d' : '#1e4d92'};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    background: ${props => props.secondary ? '#5a6268' : '#163a6f'};
  }
`;

const ConfirmationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { formData, photoPreview } = location.state || { formData: {}, photoPreview: null };

  // Adicionar verificação de dados
  if (!location.state) {
    return (
      <Container>
        <Card>
          <Title>Erro</Title>
          <p>Nenhum dado encontrado. Por favor, retorne ao formulário de cadastro.</p>
          <ButtonGroup>
            <Button secondary onClick={() => navigate('/register')}>
              Voltar ao Cadastro
            </Button>
          </ButtonGroup>
        </Card>
      </Container>
    );
  }

  const handleEdit = () => {
    navigate('/register', { state: { formData, photoPreview } });
  };

  const handleConfirm = () => {
    navigate('/success', { state: { formData, photoPreview } });
  };

  return (
    <Container>
      <Card>
        <Title>Confirme seus Dados</Title>
        <DataDisplay>
          <img src={photoPreview} alt="Foto" style={{ width: 100, height: 100, borderRadius: '50%' }} />
          <h3>Nome: {formData.name}</h3>
          <p>Email: {formData.email}</p>
          <p>Telefone: {formData.phone}</p>
          <p>Tipo Sanguíneo: {formData.bloodType}</p>
          <p>Contato de Emergência: {formData.emergencyContact}</p>
          <p>Telefone de Emergência: {formData.emergencyPhone}</p>
          <p>Condições Médicas: {formData.medicalConditions}</p>
        </DataDisplay>
        <ButtonGroup>
          <Button secondary onClick={handleEdit}>Editar</Button>
          <Button onClick={handleConfirm}>Confirmar</Button>
        </ButtonGroup>
      </Card>
    </Container>
  );
};

export default ConfirmationPage;